import React from 'react';
import { useDispatch } from 'react-redux';
import { commonActions } from '@lialo/core/lib/pages/common';
import { useServiceProvider } from '../Providers';

interface IProps {
  url: string;
  snackbarKey: string;
  onShare?: () => void;
  button: React.ReactElement<{ onClick: () => void }>;
}

const SharePageButton = (props: IProps) => {
  const { shareService } = useServiceProvider();
  const supportsSharing = shareService.supportsSharing();
  const dispatch = useDispatch();

  const share = async () => {
    if (supportsSharing) {
      try {
        await shareService.share({ url: props.url });
        props.onShare && props.onShare();
      } catch (e) {
        // probably cancellation
      }
    } else {
      shareService.copyToClipboard(props.url);
      props.onShare && props.onShare();
      dispatch(
        commonActions.showSnackbar({
          key: props.snackbarKey,
        })
      );
    }
  };

  return React.cloneElement(props.button, { onClick: share });
};

export default SharePageButton;
